import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { getDiameter } from '../Api'

export default generateApiAction({
  baseType: Types.DIAMETERS.GET,
  api: getDiameter,
  responseType: RESPONSETYPE.DATA
})



// WEBPACK FOOTER //
// ./src/actions/diameters/GetAction.js